import { useTranslation } from 'react-i18next';
import { Row, Column, Text, Spacer, withErrorBoundary } from '@oliasoft-open-source/react-ui-library';
import translations from 'src/internationalisation/translation-map.json';
import { convertToKebabCase } from 'client/common/utils/string-utils.ts';

interface TaskOffsetHeaderProps {
  task: string | undefined;
  operation: string | undefined;
  section: string | undefined;
}

const TaskOffsetHeader = ({ task, operation, section }: TaskOffsetHeaderProps) => {
  const { t } = useTranslation();

  return (
    <>
      <Row spacing={0}>
        <Text muted>{t(translations.filteringOn)}</Text>
      </Row>
      <Row spacing={0}>
        <Column flex={false}>
          <Row spacing={0}>
            <Text bold>{t(translations.section)}: </Text>
            <Spacer width="var(--padding-xs)" />
            <div data-testid={`offset-well-summary-overlay-header-text-${convertToKebabCase(translations.section)}`}>
              <Text>{section}</Text>
            </div>
          </Row>
        </Column>
        <Spacer width="var(--padding-sm)" />
        <Column flex={false}>
          <Row spacing={0}>
            <Text bold>{t(translations.operation)}: </Text>
            <Spacer width="var(--padding-xs)" />
            <div data-testid={`offset-well-summary-overlay-header-text-${convertToKebabCase(translations.operation)}`}>
              <Text>{operation}</Text>
            </div>
          </Row>
        </Column>
        <Spacer width="var(--padding-sm)" />
        <Column flex={false}>
          <Row spacing={0}>
            <Text bold>{t(translations.activity)}: </Text>
            <Spacer width="var(--padding-xs)" />
            <div data-testid={`offset-well-summary-overlay-header-text-${convertToKebabCase(translations.activity)}`}>
              <Text>{task}</Text>
            </div>
          </Row>
        </Column>
      </Row>
    </>
  );
};

const Container = withErrorBoundary(TaskOffsetHeader, { style: { position: 'absolute', bottom: 0, zIndex: 1000 } });

export { Container as TaskOffsetHeader };
